import React from "react";

const DiscordIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M20.317 4.37a19.79 19.79 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.058a.082.082 0 0 0 .031.056 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028c.462-.63.874-1.295 1.226-1.994a.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128c.126-.094.252-.192.372-.291a.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.009c.12.099.246.198.373.292a.077.077 0 0 1-.006.127 12.3 12.3 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.029 19.84 19.84 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03ZM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418Zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418Z" />
  </svg>
);

const InstagramIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
  </svg>
);

export default function CommunityBanner({ settings }) {
  const discord = (settings?.discord_url || "").trim();
  const instagram = (settings?.instagram_url || "").trim();
  if (settings?.show_community === false || (!discord && !instagram)) return null;
  return (
    <div className="container-x" style={{ marginTop: 24 }}>
      <section className="brand-gradient community-banner" data-testid="community-banner">
        <div>
          <h3 style={{ margin: 0, fontSize: 18, fontWeight: 500, color: "#fff" }}>Join the Clipup community</h3>
          <p style={{ margin: "4px 0 0", fontSize: 13, color: "#c9d4ff" }}>Campaign drops, payout updates, and clipping tips.</p>
        </div>
        <div className="community-btns">
          {discord && (
            <a href={discord} target="_blank" rel="noreferrer" className="community-btn" data-testid="community-discord" style={{ background: "#5865F2", color: "#fff", border: "none" }}>
              <DiscordIcon /> Join Discord
            </a>
          )}
          {instagram && (
            <a href={instagram} target="_blank" rel="noreferrer" className="community-btn" data-testid="community-instagram" style={{ background: "transparent", color: "#fff", border: "0.5px solid rgba(255,255,255,.3)" }}>
              <InstagramIcon /> Follow us
            </a>
          )}
        </div>
      </section>
    </div>
  );
}
